const Form101EN = {
    stepName: {
        importantNotes: "Important Notes",
        post: "Post(s) Applied For",
        personalParticulars: "Personal Particulars",
        educationQualifications: "Education and Qualifications",
        bachelorAndMaster: "Bachelor’s and Master’s Degrees",
        teacherTraining: "Teacher Training and Professional Qualifications",
        languageProficiency: "Language Proficiency and Other Tests",
        supplementaryInformation:
            "Supplementary Information (for particular post(s))",
        workingExperience: "Working Experience",
        otherInformation: "Other Information (Optional)",
        supportingDocument: "Supporting Document(s)",
        declaration: "Declaration",
        confirmation: "Confirmation",
    },
    importantNotes: {
        title: "Notes for Applicants",
        title1: "General notes",
        title2: "Points to note during completion of application",
        title3: "Points to note after submission of application",
        title4: "Enquiries",
    },
    importantNotesStep: [
        {
            textBefore:
                "Before making an online application through this system, please check your computer configuration requirements by referring to the “",
            text: "Computer System Configuration",
            textAfter: "”.",
        },
        {
            text: "The Education Bureau (EDB) will acknowledge receipt, through email, of completed online application, amendment, submission of supplementary information <b>within 2 hours</b> after your successful submission. To ensure a successful transmission of your application and our acknowledgement, you <b>must</b> enter your email address <b>correctly</b> on the online application. Subsequent change of email address through the system is not allowed. ",
        },
        {
            text: "An online reference number will only be generated after you have submitted the online application form. Please quote this number in all future communications with the Appointments and Personnel (AP) Section of EDB.",
        },
        {
            text: "You must provide all the personal data requested in this form, except those items clearly marked as optional. You should particularly note that EDB may require you to provide specific details to support your application for individual vacancies. You should refer to the recruitment advertisement for such requirements in filling in this form. <u>Your application will not be considered</u> if you fail to provide all information as requested or it is not clear from the information provided that you have the minimum qualifications, training, experience or other requirements specified for the job.",
        },
        {
            text: "The personal data provided in this form will be used for recruitment, other employment-related and human resource management-related purposes. It may be provided to government departments and other organisations or agencies authorised to process the information for purposes relating to recruitment by and employment with the Government e.g. qualifications assessment, medical examination, employer reference and integrity checking, etc. as may be necessary. Personal data of an unsuccessful applicant will normally be destroyed by EDB 24 months after rejection of the applicant’s application.",
        },
        {
            text: "You may submit one online application form to apply for more than one job in EDB currently being advertised for recruitment.",
        },
        {
            text: "If you hold any academic and/or professional qualifications obtained from institutions or professional bodies, please upload copies of your diplomas/certificates, transcripts of studies and official documents stating the mode of delivery of the qualifications (e.g. full time/part time, on campus/distance learning, etc.) to EDB when completing the online application not later than the closing date for application as set out by EDB. To facilitate assessment of the qualifications, the documents of any other prior qualifications obtained should also be supplied as far as possible.",
        },
        {
            text: "If you cannot complete the whole application within <b>2 hours</b>, you can use the “SAVE” button to save the parts you have input. You can then restore the saved data into the application form when you login the system with your email address or “iAMSmart” again for continuation of the application. The saved data is linked with your email address which cannot be changed afterwards.",
        },
        {
            text: "You can enter this system within the application period with your email address or “iAMSmart” to enquire or amend the application data, or to provide supplementary information.",
        },
        {
            text: "The system will recap the data input on screen after you press the “NEXT” button in Step 8. After verifying the data, please print the data for own reference and press the “SUBMIT” button to complete the application.",
        },
        {
            text: "Recruitment advertisements will be removed from the website after close of application. Please keep a copy of the recruitment advertisement of each job for which you have applied for future reference.",
        },
        {
            text: "EDB may communicate and/or, if deemed fit, offer appointment to you via the email address provided in this application form. You are advised to frequently and periodically check your email account (including the folders for spam, bulk and junk mails). If you fail to act in time in accordance with any email instructions from EDB, your application will not be considered or any offer of appointment will automatically lapse.",
        },
        {
            text: "Please contact the AP Section of EDB if:-",
        },
    ],
    contactEDBInfo: {
        info1: "you do not receive any acknowledgement within 2 hours after you have submitted your application online;",
        info2: "there are any subsequent changes to the information provided, including any change to your permanent resident status of the Hong Kong Special Administrative Region, after successfully submitting the online application;",
        info3: "you are required to correct or access to personal data after submission of the application form; or",
        info4: "you have any enquiries on recruitment matters.",
    },
    contactInfo: {
        title: "<sup>♯</sup>The contact information of the AP Section of EDB are as follows: –",
        post: "<u>Post(s) Applied For</u>",
        tel: "<u>Contact numbers</u>",
        postOne:
            "Assistant Education Officer (Administration) / Specialist (Education Services) I / Specialist (Education Services) II / Speech Therapist",
        telOne: "2892 6177",
        postTwo: "",
        postThree: "Assistant Inspector (Graduate)",
        telThree: "2892 6175",
        postFour: "Assistant Education Officer",
        telFour: "2892 5958",
        postFive: "Assistant Primary School Master/Mistress",
        telFive: "2892 5978",
    },
    label: {
        addJob: "ADD POST",
        jobPeriodStart: "Period Start",
        jobPeriodEnd: "Period End",
        jobTitle: "Job Title",
        publish: "Publish",
        subject: "Subjects",
        english: "Eng(LPA)",
        otherEnglish: "Eng(Others)",
        math: "Maths",
        putonghua: "PTH(LPA)",
        supplementary: "Supplementary",
        dailyStatistics: "Daily Statistics for Reviewers",
        name: "Name",
        userName: "Interface Username",
        email: "Email",
        title: "Title",
        englishSurname: "Name in English (Surname)",
        englishOtherName: "Name in English (Other names)",
        chineseName: "Name in Chinese",
        chineseNameCode: "Chinese Name in Code",
        dateBirth: "Date of Birth",
        sexCode: "Sex",
        hkidCardNo: "Hong Kong Identity Card Number",
        hkCardNumText: "(For candidates without Hong Kong Identity Card)",
        passport: "Passport/Travel Document Number",
        issuingAuthority: "Issuing Authority",
        permanentResident:
            "Are you a permanent resident of the Hong Kong Special Administrative Region?",
        residentialAddress: "Residential Address",
        Room: "Room/Flat",
        Floor: "Floor",
        Block: "Block/Building",
        Estate: "Estate",
        Road: "Road/Street",
        District: "District",
        Country: "Country / Region",
        correspondenceAddress: "Correspondence Address ",
        correspondenceAddressText:
            "(if different from the residential address above)",
        contactNum1: "Mobile Phone",
        contactNum2: "Residential Telephone Number",
        applicantEmail: "E-mail Address",
        reEnterEmail: "Re-enter E-mail Address",
        residenceText:
            "Length of Residence in Hong Kong (with dates in chronological order)",
        residenceFrom: "From",
        residenceTo: "To",
        residenceDuration: "Duration (Year-Month)",
        residenceTotal: "Total",
        automaticCalculation: "Automatic calculation",
        bachelorDegree: "Bachelor’s Degree(s)",
        programmeName: "Programme Name",
        institute: "Institute",
        attendanceMode: "Mode of Attendance",
        programmeDuration: "Duration of Programme (Year) (e.g. 3)",
        programmeDurationLabel: " (e.g. 3)",
        awardYear: "Award Year / Expected Award Year",
        majorSubject: "Major Subject(s)",
        minorSubject: "Minor Subject(s)",
        masterOfPostGraduateStudies:
            "Master’s / Doctoral Degree(s) or Post-graduate Studies",
        otherSpecify: "please specify",
        teacherTraining: "Teacher Training",
        professionalQualifications:
            "Professional and Other Qualifications (e.g. Associate Degree, Higher Diploma, etc.)",
        qualifications: "Qualifications",
        issuingAuthorityOrInstitute: "Issuing Authority / Institute",
        levelAttained: "Level Attained / to be Attained",
        dateObtained: "Date Obtained / to be Obtained",
        otherInformation:
            "Record of Voluntary Service (in chronological order)",
        nameOfAgency: "Name of Organisation / Agency",
        positionHeld: "Position Held",
        workFrom: "From",
        workTo: "To",
        candidate: "Are you a candidate with disability?",
        natureAndDegree:
            "If yes, please indicate nature and degree of disability",
        labelOne:
            "Please specify whether you need special arrangement for taking the examination/attending an interview",
        examination: "Examination",
        examinationRequired:
            "If yes, please specify the arrangement required for examination",
        interview: "Interview",
        interviewRequired:
            "If yes, please specify the arrangement required for interview",
        bestResultsInCNSubject: "Best Results in Chinese Language Subject",
        secondaryEducationExamination:
            "(i) Hong Kong Diploma of Secondary Education Examination",
        secondaryEducationExaminationofEn:
            "(i) Hong Kong Diploma of Secondary Education Examination - English Language",
        secondaryEducationExaminationofCn:
            "(i) Hong Kong Diploma of Secondary Education Examination - Chinese Language",
        advancedLevelExamination: "(ii) Hong Kong Advanced Level Examination",
        advancedLevelExaminationofEn:
            "(ii) Hong Kong Advanced Level Examination - Use of English",
        advancedLevelExaminationofCn:
            "(ii) Hong Kong Advanced Level Examination - Chinese Language and Literature or Chinese Lanquage and Culture",
        cnCulture: "Chinese Language and Culture",
        cnLiterature: "Chinese Language and Literature",
        CRE: "(iii) Common Recruitment Examination (CRE) - Use of Chinese",
        level: "Level",
        testDate: "Date of test",
        selectPlaceHolder: "Please select an option",
        documentNoteList: {
            1: "To facilitate the assessment of the qualifications, candidates should upload the following documents and all other relevant qualifications obtained as far as possible <span class='closing-date'>on or before the closing date for application</span> –",
            2: "1.Bachelor / Master / Doctoral Degree Certificate(s) and Transcript(s)",
            3: "2.Teacher Training Certificate(s) and Transcript(s)",
            4: "3.Others, such as deed poll, etc.",
        },
        documentNote:
            "Remarks:<br/>i) A maximum of five (5) files can be uploaded at one time.  The size of uploaded file(s) should not exceed the total allocated limit of 10MB.<br/>ii) Please ensure that the uploaded files(s) is/are clear and legible, and should be in one of the following formats : JPEG, PDF, GIF, PNG.<br/>iii) Other supporting document(s) may be requested at a later stage to facilitate the assessment of the applicants' qualifications, if deemed necessary.<br/>iv) Please do not upload a password protected file.",
        informationNote:
            "Note: Candidates with disabilities are considered on equal terms with other applicants.  The Education Bureau may require medical proof of their disability if candidates wish to make use of the appointment arrangements applicable to candidates with disabilities.",
        declarationList: {
            1: "I confirm that I meet all the entry requirements, and have uploaded / will upload the supporting documents stipulated in the recruitment advertisement not later than the closing date for application.",
            2: "I understand that if I wilfully give any false information or withhold any material information in this application form, or fail to notify the EDB any subsequent change of information provided, it will render me liable to disqualification for employment by the Government or termination of employment, if already employed by the Government.",
            3: "I consent to the Government making any necessary enquiries for purposes relating to recruitment by and employment with the Government and for the verification of the information given above. I authorise all government departments and other organisations or agencies to release any record or information as may be required for these enquiries (including, inter alia, obtaining a reference/performance appraisal report(s) from my current and/or previous employer(s) before offer of appointment; obtaining my medical examination reports, medical board reports or medical records from relevant authorities/agencies/medical personnel and transferring of such data to other authorities/agencies/medical personnel; and making enquiries from relevant government departments/institutions/agencies regarding my academic/language/professional qualifications and obtaining relevant records and transferring of such data to other government departments/authorities/agencies for qualifications assessment). I hereby authorize the Commissioner of Police, or his representative, to release full particulars of any and all criminal convictions recorded against me to relevant government departments/authorities/agencies. I also agree to my fingerprint impressions being taken by the Police in connection with this application, if required for the purpose of verifying my criminal records.",
            4: "I understand and accept that the information given above will be provided to government departments and other organisations or agencies authorised to process the information for recruitment, other employment-related and human resource management-related purposes, e.g. qualifications assessment, medical examination, employer reference and integrity checking, etc. as may be necessary.",
        },
        declarationNote:
            "Note: Please insert a “✓”in all the boxes below to indicate that you have read, understood and accepted all conditions in this section. Otherwise, your application will not be processed further.",
        agreement:
            "I certify that I have read, fully understand and accept all conditions above.",
        bestResultsInENSubject: "Best Results in English Language Subject",
        CREofEn: "(v) Common Recruitment Examination (CRE) - Use of English",
        IELTS: "(iii) International English Language Testing System (IELTS) (Academic Module)",
        overallBand: "Overall Band",
        listeningBand: "Listening Band",
        readingBand: "Reading Band",
        writingBand: "Writing Band",
        speakingBand: "Speaking Band",
        testDateofEn: "Date of test",
        advancedLevel:
            "(iv) General Certificate of Education (Advanced Level) - English Language",
        nationalSecurityResult:
            "Basic Law and National Security Law Test (BLNST)",
        nationalSecurityResultMsg:
            "(The results of the “Basic Law Test” are not equivalent to the results of the “Basic Law and National Security Law Test”.)",
        nationalSecurityResultNote:
            "(Note: For all civil service recruitment exercises advertised on or after 28 July 2023, applicants could apply for the BLNST conducted by the Civil Service Bureau, the Education Bureau or various recruiting departments/grades, the pass result of which is mutually acceptable for applying for both civil service jobs and teaching posts in publicly-funded schools or kindergartens joining the Kindergarten Education Scheme, regardless of whether the BLNST is conducted before or after 28 July 2023.)",
        nationalSecurityResultTitle:
            'Have you attained a pass result in the test(s) below? (Please select as appropriate. If you have not attended any of the test(s) below, please select "N.A".)',
        result: "(a) BLNST (Degree/Professional Grades) (conducted by the Civil Service Bureau or recruiting departments/grades)",
        nationalSecurityResultLevel:
            "(b) BLNST (Degree Level) (conducted by the Education Bureau)",
        languageCommission:
            "The State Language Commission – the Test of Proficiency in Putonghua",
        grade: "Grade",
        AEOorAPSMSupplementary:
            "Supplementary Information on English Language subject",
        englishLanguage: "English Language",
        LPATEnglish:
            "(i) Language Proficiency Assessment (LPA) (formerly known as the Language Proficiency Assessment for Teachers (LPAT)) (English Language)",
        reading: "Reading",
        writing: "Writing",
        listening: "Listening",
        speaking: "Speaking",
        classroomAssessment: "Classroom Language Assessment",
        levelAttainedofEnglish: "Level Attained",
        obtainedDate: "Date Obtained/Exempted",
        AEOSupplementary:
            "Supplementary information to be completed by applicants who apply for AEO (English Language)",
        GCEExaminations:
            '(ii) General Certificate of Education (GCE) Examinations (London Examinations) / GCE Ordinary Level (Overseas) Examination (GCE "O" Level Overseas)',
        obtainedDateOfMY: "Date Obtained",
        IGCSEForEnglish:
            "(iii) International General Certificate of Secondary Education Examination (IGCSE) - English (First/Second) Language",
        instituteMembership: "(iv) Membership of Institute of Linguists",
        othersSpecify: "Others (Please specify)",
        MathSupplementary: "Supplementary Information on Mathematics subject",
        compulsoryPart: "Compulsory Part",
        calculusStatistics:
            "Extended Part - Module 1 (Calculus and Statistics)",
        algebraCalculus: "Extended Part - Module 2 (Algebra and Calculus)",
        hkCertificateOfExamination:
            "(iii) Hong Kong Certificate of Education Examination",
        year2006OrBefore: "Year 2006 or before",
        year2007OrBefore: "Year 2007 or after",
        PutonghuaSupplementary:
            "Supplementary Information on Putonghua subject",
        LPATPutonghua:
            "(i) Language Proficiency Assessment (LPA) (formerly known as the Language Proficiency Assessment for Teachers (LPAT)) (Putonghua)",
        AttainedLevel3: "Attained Level 3 or above",
        workingExperience:
            "Full Employment Record to date (including past government employment and part-time job) (in chronological order)",
        schoolName: "Name of School / Organisation",
        fullTimeOrPartTime: "Full-time / Part-time",
        natureWork: "Nature of Work",
        subjectTaught: "Subject(s) Taught",
        levelTaught: "Level(s) Taught",
        periodOfdmy: "Period",
        employmentDuration: "Duration of full-time employment",
        dutiesDescription:
            "Description of duties (e.g. classroom teaching, setting examination paper, etc.)",
        fullTimeEmployment: "Total Full-time Employment",
        disciplinaryOffence:
            "If you are serving or have ever served in the Government, do you have any previous record(s) of disciplinary offence whilst in employment with the Government?",
        disciplinaryOffenceDetails: "If yes, please give details",
        disciplinaryOffenceNote:
            "(Note: A record of disciplinary offence is not necessarily a barrier to Government employment.)",
        workingExperienceFrom: "From",
        workingExperienceTo: "To",
        postTitle:
            "Please select the post(s) you would like to apply for <span class='danger'>*</span>",
        period: "Period",
        otherInformationTitle: "Other information (Optional)",
        type: "Type",
        validityDate: "Validity Date",
        creTestDate: "Date of test",
        equivalentLevel2: "Equivalent to Level 2",
        bestResultCnMsg:
            "Please note that you cannot meet the language proficiency requirement of the post(s) (i.e. “Level 2” in the Use of Chinese paper in the Common Recruitment Examination, or equivalent). Your application cannot be processed further. For details of the language proficiency requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        bestResultEnMsg:
            "Please note that you cannot meet the language proficiency requirement of the post(s) (i.e. “Level 2” in the Use of English paper in the Common Recruitment Examination, or equivalent). Your application cannot be processed further. For details of the language proficiency requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        bestResultEnAndCnMsg:
            "Please note that you cannot meet the language proficiency requirements of the post(s) (i.e. “Level 2” in the Use of Chinese and Use of English papers in the Common Recruitment Examination, or equivalent). Your application cannot be processed further. For details of the language proficiency requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        notedContinue: "Noted and Continue",
        guiltyOffence:
            "Have you ever been found guilty of an offence in a court of law whether or not in Hong Kong?",
        guiltyOffenceDetails: "If yes, please give details",
        servingServed: "Are you serving or have ever served in the Government?",
        servingServedYesMsg:
            "If you are serving or have ever served in the Government, have you signed a declaration that you will uphold the Basic Law of the Hong Kong Special Administrative Region of the People’s Republic of China, bear allegiance to the Hong Kong Special Administrative Region of the People’s Republic of China (“HKSAR”), be dedicated to your duties and be responsible to the HKSAR Government?",
        noneOption: "Please select",
        importantNotes:
            "I confirm that I have read and fully understand the Important Notes above.",
        noted: "Noted",
        timeoutNote:
            "Note: Your application will be closed automatically after login for more than 2 hours and/or system under idling for more than 30 minutes.",
        timeoutMsg:
            "Your application will be closed in {{minutes}} minutes automatically. Please be reminded to complete/save your application before logout.",
        supplementaryInfo: "Supplementary Information",
        guiltyOffenceNote:
            "(Note: Please refer to the Rehabilitation of Offenders Ordinance (Cap. 297) (“the Ordinance”). Your particular attention is drawn to the exception set out in section 4(2)(c) of the Schedule of the Ordinance. Section 4(2)(c) of the Ordinance provides that the provisions under section 2(1) and (1A) for protection of rehabilitated persons do not apply to the questions relating to the appointment to the prescribed offices. The prescribed offices are set out in the Schedule to the Ordinance which include ‘any office occupied, or to be occupied, by an officer on or above Point 27 on the Master Pay Scale (“MPS”)’. For example, if you are applying for a post with pay scale from MPS Point 25 to 33, since this post will be occupied by an officer on or above MPS 27, the protection of rehabilitated persons under the provision of section 2(1) and (1A) will not be applicable to this case and all offences (if any) of which you have been found guilty must be declared. Failure to do so may exclude you from the appointment. If you are not certain about the pay scale of the post you are applying for, please consult the Education Bureau.)",
        servingServedNote:
            "(Note: All civil servants of the Government of the Hong Kong Special Administrative Region of the People’s Republic of China (“HKSAR Government”) and Government staff appointed on non-civil service terms are required to sign a declaration that they will uphold the Basic Law of the Hong Kong Special Administrative Region of the People’s Republic of China, bear allegiance to the Hong Kong Special Administrative Region of the People’s Republic of China, be dedicated to their duties and be responsible to the HKSAR Government.)",
        employmentNote:
            "(Note: The nature and relevancy of the working experience of the applicant will be subject to further assessment.)",
        permanentResidentNote:
            "Please note that candidates must be permanent residents of the Hong Kong Special Administrative Region <b>at the time of appointment</b> unless specified otherwise.",
        permanentResidentMsg:
            " (If in doubt, you are advised to make enquiry about your eligibility for the permanent resident status in the Hong Kong Special Administrative Region through the Immigration Department Right of Abode Enquiry Hotline 2824 6111.)",
        previewPDF:
            "If you wish to print and/or download the application in PDF format, please press “PREVIEW PDF” button below.",
        LPATEnglishNote:
            "Please be reminded that you should have attained ‘Level 3’ or above in English Language in the Language Proficiency Assessment (LPA) (formerly known as the Language Proficiency Assessment for Teachers (LPAT)) or been exempted from the said language proficiency requirement at the time of appointment unless specified otherwise.",
        LPATPutonghuaNote:
            "Please be reminded that you should have attained ‘Level 3’ or above in Putonghua in the Language Proficiency Assessment (LPA) (formerly known as the Language Proficiency Assessment for Teachers (LPAT)) at the time of appointment unless specified otherwise.",
        AEOAandAIG4yearsNote:
            "Please note that you cannot meet the working experience requirements for the post of Assistant Inspector (Graduate). Your application cannot be processed further. You may consider to amend the application. For details of the working experience requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        SES14yearsNote:
            "Please note that you cannot meet the working experience requirement for the post of S(ES)I. Your application cannot be further processed. You may amend the application by updating the post(s) applied for and/or other entries. For details of the working experience requirements of the posts, please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during normal working hours or email to edbappt@edb.gov.hk",
        AEOAandorAIG3yearsNote:
            "Please note that you cannot meet the working experience requirements of the post(s). Your application cannot be processed further. You may consider to amend the application. For details of the working experience requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        AIG4yearsNote:
            "Please note that you cannot meet the working experience requirements of the post(s). Your application cannot be processed further. You may consider to amend the application. For details of the working experience requirements of the post(s), please refer to the job advertisements. For enquiries, please contact the Appointments and Personnel Section of EDB at 2892 6686 during working hours or email to edbappt@edb.gov.hk.",
        placeOfBirth: "Place of Birth",
        postSelectNote:
            "Note: You can select more than one post in this application",
        autosuggestGroupText: "Please select and / or enter free text",
        professionalMsgForSE:
            "For the post of Assistant Inspector (Graduate) (Special Education): Please state the relevant training in Special Education received in the part of “Professional and Other Qualifications”.",
        workingExperienceMsgForSE:
            "For the post of Assistant Inspector (Graduate) (Special Education): Please elaborate in the field of “Description of duties” on whether possessing four years’ relevant post-degree experience that involve teaching and/or providing support to students with special educational needs and/or teaching in special schools, or equivalent.  Please provide the details including but not limited to the name of school/organisation, position held, level(s) taught/served and period(s) concerned.",
        workingExperienceMsgForKindergarten:
            "For the post of Assistant Inspector (Graduate) (Kindergarten): Please elaborate in the field of “Description of duties” on whether possessing four years’ relevant post-degree experience that involve teaching or working with early years children.  Please provide the details including but not limited to the name of school/organisation, position held, level(s) taught/served and period(s) concerned.",
        workingExperienceMsgForCounselling:
            "For the post of Assistant Inspector (Graduate) (Counselling, Guidance and Discipline): Please elaborate in the field of “Description of duties” on whether possessing four years’ relevant post-degree working experience that involve teaching, guidance/discipline or counselling work with children.  Please provide the details including but not limited to the name of school/organisation, position held, level(s) taught/served and period(s) concerned.",
        workingExperienceMsgForCitizenship:
            "For the post of Assistant Inspector (Graduate) (Citizenship and Social Development): Please elaborate in the field of “Description of duties” on whether possessing four years’ relevant post-degree working experience that include at least three years of teaching experience fully covering the senior secondary levels 4, 5 and 6 in the subjects of Liberal Studies.  Please provide the details including but not limited to the name of school/organisation, position held, level(s) taught and period(s) concerned.",
        specialEducation: "Special Education",
        nonSpecialEducation: "Non-Special Education",
        computerSystemConfiguration: "Computer System Configuration",
        computerSystemConfigurationText1:
            "To ensure that our service can be delivered correctly and effectively, we recommend users to use the latest version of <b>Microsoft Edge, Mozilla Firefox, Safari or Google Chrome</b> for the best viewing.",
        computerSystemConfigurationText2:
            "The Education Bureau will not be liable for any errors in, omissions from, delays or misstatements or misrepresentations (whether express or implied) concerning any job enquiries / applications, however, arising from the malfunction of operation system / internet web browser combinations.",
        iamsmartContent: `You may use the personal information stored in "iAM Smart e-ME" for online form filling. Please click the "Form Filling with iAM Smart e-ME" button.`,
        append: "Add",
        fileUploadMsg: "Choose File",
        switchLangContent:
            "If you choose to switch the language, you will be redirected to the first page of the application form and all the information you have input will not be transferred.",
        switchLangContent2:
            "Please confirm if you would continue to switch the language.",
        successfulSubmissionMsg1: "You have successfully submitted the form.",
        successfulSubmissionMsg2:
            "A confirmation email has been sent to your email address.",
        servedEDBNote:
            "Are you serving or have you ever served in the Education Bureau?",
        servedSchoolNote:
            "Which Government School(s)/Division(s) and/or Section(s) of the Education Bureau are you serving or have you served?",
        schoolOrDivision: "School/Division/Section",
        fromDate: "From",
        toDate: "To",
        englishBestResultsNote:
            "(Note: If you are applying for Assistant Education Officer / Assistant Primary School Master/Mistress (English Language), please input your IELTS results below, if applicable.)",
        englishSupplementaryNote:
            "(Note: Please input the results of the Language Proficiency Assessment below AND/OR the results of the International English Language Testing System (IELTS) (Academic Module) under Step 4.3.)",
    },
    options: {
        titleOp: {
            Dr: "Dr",
            Miss: "Miss",
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
        },
        sexCodeOp: {
            M: "Male",
            F: "Female",
        },
        permanentResidentOp: {
            Yes: "Yes",
            No: "No",
        },
        districtOldOp: {
            KC: "Kowloon City",
            KT: "Kwun Tong",
            SSP: "Shum Shui Po",
            WTS: "Wong Tai Sin",
            YTM: "Yau Tsui Mong",
            CW: "Central and Western",
            HKE: "Eastern",
            SOU: "Southern",
            WCH: "Wan Chai",
            I: "Islands",
            KWT: "Kwai Tsing",
            N: "North",
            SK: "Sai Kung",
            ST: "Sha Tin",
            TP: "Tai Po",
            TW: "Tsuen Wan",
            TM: "Tuen Mun",
            YL: "Yuen Long",
        },
        districtOp: {
            "Central and Western District": {
                Admiralty: "Admiralty",
                Central: "Central",
                "Kennedy Town": "Kennedy Town",
                "Mid-levels": "Mid-levels",
                "Sheung Wan": "Sheung Wan",
                "Shek Tong Tsui": "Shek Tong Tsui",
                "Sai Ying Pun": "Sai Ying Pun",
                "The Peak": "The Peak",
                "West Point": "West Point",
            },
            "Eastern District": {
                "Braemar Hill": "Braemar Hill",
                "Chai Wan": "Chai Wan",
                "Fortress Hill": "Fortress Hill",
                "Heng Fa Chuen": "Heng Fa Chuen",
                "North Point": "North Point",
                "Quarry Bay": "Quarry Bay",
                "Shau Kei Wan": "Shau Kei Wan",
                "Siu Sai Wan": "Siu Sai Wan",
                "Sai Wan Ho": "Sai Wan Ho",
                "Tin Hau": "Tin Hau",
                "Tai Koo": "Tai Koo",
            },
            "Southern District": {
                Aberdeen: "Aberdeen",
                "Ap Lei Chau": "Ap Lei Chau",
                "Chung Hom Kok": "Chung Hom Kok",
                "Deep Water Bay": "Deep Water Bay",
                "Pok Fu Lam": "Pok Fu Lam",
                "Repulse Bay": "Repulse Bay",
                "Shouson Hill": "Shouson Hill",
                "Shek O": "Shek O",
                Stanley: "Stanley",
                "Tai Tam": "Tai Tam",
                "Tin Wan": "Tin Wan",
                "Wong Chuk Hang": "Wong Chuk Hang",
                "Wong Nai Chung": "Wong Nai Chung",
            },
            "Wan Chai District": {
                "Causeway Bay": "Causeway Bay",
                "Happy Valley": "Happy Valley",
                "So Kon Po": "So Kon Po",
                "Tai Hang": "Tai Hang",
                "Wan Chai": "Wan Chai",
            },
            "Kowloon City District": {
                "Ho Man Tin": "Ho Man Tin",
                "Hung Hom": "Hung Hom",
                "Kowloon City": "Kowloon City",
                "Kowloon Tong": "Kowloon Tong",
                "Kai Tak": "Kai Tak",
                "Ma Tau Chung": "Ma Tau Chung",
                "Ma Tau Wai": "Ma Tau Wai",
                "To Kwa Wan": "To Kwa Wan",
                Whampoa: "Whampoa",
            },
            "Kwun Tong District": {
                "Cha Kwo Ling": "Cha Kwo Ling",
                "Kowloon Bay": "Kowloon Bay",
                "Kwun Tong": "Kwun Tong",
                "Lam Tin": "Lam Tin",
                "Lei Yue Mun": "Lei Yue Mun",
                "Ngau Tau Kok": "Ngau Tau Kok",
                "Sau Mau Ping": "Sau Mau Ping",
                "Yau Tong": "Yau Tong",
            },
            "Sham Shui Po District": {
                "Cheung Sha Wan": "Cheung Sha Wan",
                "Lai Chi Kok": "Lai Chi Kok",
                "Mei Foo": "Mei Foo",
                "Nam Cheong": "Nam Cheong",
                "Stonecutters Island": "Stonecutters Island",
                "Shek Kip Mei": "Shek Kip Mei",
                "Sham Shui Po": "Sham Shui Po",
                "Tai Kok Tsui": "Tai Kok Tsui",
                "Tai Wo Ping": "Tai Wo Ping",
                "Yau Yat Tsuen": "Yau Yat Tsuen",
            },
            "Wong Tai Sin District": {
                "Choi Hung": "Choi Hung",
                "Diamond Hill": "Diamond Hill",
                "Lok Fu": "Lok Fu",
                "Ngau Chi Wan": "Ngau Chi Wan",
                "San Po Kong": "San Po Kong",
                "Tsz Wan Shan": "Tsz Wan Shan",
                "Wang Tau Hom": "Wang Tau Hom",
                "Wong Tai Sin": "Wong Tai Sin",
            },
            "Yau Tsim Mong District": {
                "Ferry Point": "Ferry Point",
                Jordan: "Jordan",
                "Mong Kok": "Mong Kok",
                "Prince Edward": "Prince Edward",
                "Tsim Sha Tsui": "Tsim Sha Tsui",
                "West Kowloon": "West Kowloon",
                "Yau Ma Tei": "Yau Ma Tei",
            },
            "Islands District": {
                "Cheung Chau": "Cheung Chau",
                "Cheung Sha Lantau Island": "Cheung Sha Lantau Island",
                "Chek Lap Kok Lantau Island": "Chek Lap Kok Lantau Island",
                "Chi Ma Wan Lantau Island": "Chi Ma Wan Lantau Island",
                "Discovery Bay Lantau Island": "Discovery Bay Lantau Island",
                Disneyland: "Disneyland",
                "Disneyland Resort": "Disneyland Resort",
                "Hei Ling Chau": "Hei Ling Chau",
                "Lantau Island": "Lantau Island",
                "Lamma Island": "Lamma Island",
                "Mui Wo Lantau Island": "Mui Wo Lantau Island",
                "Ngong Ping Lantau Island": "Ngong Ping Lantau Island",
                "Peng Chau": "Peng Chau",
                "Poi Toi Island": "Poi Toi Island",
                "Shek Pik Lantau Island": "Shek Pik Lantau Island",
                "Shek Kwu Chau": "Shek Kwu Chau",
                "Sha Lo Wan": "Sha Lo Wan",
                "Tai O Lantau Island": "Tai O Lantau Island",
                "Tong Fuk Lantau Island": "Tong Fuk Lantau Island",
                "Tung Peng Chau": "Tung Peng Chau",
                "Tung Chung Lantau Island": "Tung Chung Lantau Island",
            },
            "Kwai Tsing District": {
                "Kwai Fong": "Kwai Fong",
                "Kwai Hing": "Kwai Hing",
                "Kwai Shing": "Kwai Shing",
                "Kwai Chung": "Kwai Chung",
                "Lai King": "Lai King",
                "Shek Lei": "Shek Lei",
                "Tsing Yi": "Tsing Yi",
                "Tai Wo Hau": "Tai Wo Hau",
            },
            "North District": {
                "Crooked Island": "Crooked Island",
                Fanling: "Fanling",
                "Hang Tau": "Hang Tau",
                "Kat O": "Kat O",
                "Kwu Tung": "Kwu Tung",
                "Lo Wu": "Lo Wu",
                "Luen Wo Hui": "Luen Wo Hui",
                "Lung Yeuk Tau": "Lung Yeuk Tau",
                "Man Kam To": "Man Kam To",
                "Muk Wu": "Muk Wu",
                "Ping Che": "Ping Che",
                "Sheung Shui": "Sheung Shui",
                "Sandy Ridge": "Sandy Ridge",
                "Sha Tau Kok": "Sha Tau Kok",
                "Shek Wu Hui": "Shek Wu Hui",
                "Tsiu Hang": "Tsiu Hang",
                "Ta Kwu Ling": "Ta Kwu Ling",
                "Wong Kong Shan": "Wong Kong Shan",
            },
            "Sai Kung District": {
                "Clear Water Bay": "Clear Water Bay",
                "Fei Ngo Shan": "Fei Ngo Shan",
                "Hang Hau Sai Kung": "Hang Hau Sai Kung",
                "Kau Sai Chau": "Kau Sai Chau",
                "Lohas Park": "Lohas Park",
                "Leung Shuen Wan": "Leung Shuen Wan",
                "Po Lam": "Po Lam",
                "Po Lo Che": "Po Lo Che",
                "Pak Shek Wo": "Pak Shek Wo",
                "Pak Sha Wan": "Pak Sha Wan",
                "Pak Tam Chung": "Pak Tam Chung",
                "Pik Uk": "Pik Uk",
                "Sai Kung": "Sai Kung",
                "Sha Kok Mei": "Sha Kok Mei",
                "Tiu Keng Leng": "Tiu Keng Leng",
                "Tseung Kwan O": "Tseung Kwan O",
                "Tung Lung Chau": "Tung Lung Chau",
                "Tui Min Hoi": "Tui Min Hoi",
            },
            "Sha Tin District": {
                "A Kung Kok": "A Kung Kok",
                "Che Kung Miu": "Che Kung Miu",
                "Fo Tan Sha Tin": "Fo Tan Sha Tin",
                "Hin Keng": "Hin Keng",
                "Heng On": "Heng On",
                "Kau To Shan": "Kau To Shan",
                "Ma Liu Shui": "Ma Liu Shui",
                "Ma On Shan": "Ma On Shan",
                "Pak Shek Kok": "Pak Shek Kok",
                "Sha Tin": "Sha Tin",
                "Siu Lek Yuen Sha Tin": "Siu Lek Yuen Sha Tin",
                "Shek Mun": "Shek Mun",
                "Sha Tin Wai": "Sha Tin Wai",
                "Sui Wo": "Sui Wo",
                "Tai Wai Sha Tin": "Tai Wai Sha Tin",
                "Wu Kai Sha": "Wu Kai Sha",
            },
            "Tuen Mun District": {
                "Castle Peak Bay": "Castle Peak Bay",
                "Fu Tei Tuen Mun": "Fu Tei Tuen Mun",
                "Kau Hui": "Kau Hui",
                "Lung Kwu Tan": "Lung Kwu Tan",
                "Lam Tei Tuen Mun": "Lam Tei Tuen Mun",
                "San Hui Tuen Mun": "San Hui Tuen Mun",
                "Siu Lam Tuen Mun": "Siu Lam Tuen Mun",
                "So Kwun Wat": "So Kwun Wat",
                "Tai Lam": "Tai Lam",
                "Tuen Mun": "Tuen Mun",
            },
            "Tai Po District": {
                "Cheung Muk Tau": "Cheung Muk Tau",
                "Kau Lung Hang": "Kau Lung Hang",
                "Lam Tsuen Tai Po": "Lam Tsuen Tai Po",
                "Lam Tsuen Valley": "Lam Tsuen Valley",
                "Nam Hang": "Nam Hang",
                "Shap Sze Heung": "Shap Sze Heung",
                "Shuen Wan Tai Po": "Shuen Wan Tai Po",
                "Tai Po": "Tai Po",
                "Tai Wo": "Tai Wo",
                "Tap Mun": "Tap Mun",
                "Tai Mei Tuk": "Tai Mei Tuk",
                "Tai Po Kau": "Tai Po Kau",
                "Tai Po Market": "Tai Po Market",
                "Tai Po Tau": "Tai Po Tau",
                "Yuen Chau Tsai": "Yuen Chau Tsai",
            },
            "Tsuen Wan District": {
                "Lei Muk Shue": "Lei Muk Shue",
                "Lo Wai Tsuen Wan": "Lo Wai Tsuen Wan",
                "Ma Wan": "Ma Wan",
                "Sunny Bay": "Sunny Bay",
                "Sham Tseng": "Sham Tseng",
                "Ting Kau": "Ting Kau",
                "Tsing Lung Tau": "Tsing Lung Tau",
                "Tsuen Wan": "Tsuen Wan",
            },
            "Yuen Long District": {
                "Au Tau": "Au Tau",
                "Ha Tsuen Yuen Long": "Ha Tsuen Yuen Long",
                "Hung Shui Kiu": "Hung Shui Kiu",
                "Kam Tin Yuen Long": "Kam Tin Yuen Long",
                "Lau Fau Shan": "Lau Fau Shan",
                "Lok Ma Chau": "Lok Ma Chau",
                "Long Ping": "Long Ping",
                "Ma Tin": "Ma Tin",
                "Pat Heung Yuen Long": "Pat Heung Yuen Long",
                "Ping Shan Yuen Long": "Ping Shan Yuen Long",
                "San Tin Yuen Long": "San Tin Yuen Long",
                "Shek Kong Yuen Long": "Shek Kong Yuen Long",
                "Shap Pat Heung": "Shap Pat Heung",
                "Tam Mei Yuen Long": "Tam Mei Yuen Long",
                "Tin Shui Wai": "Tin Shui Wai",
                "Tai Shu Ha": "Tai Shu Ha",
                "Tai Sang Wai": "Tai Sang Wai",
                "Tai Tong Yuen Long": "Tai Tong Yuen Long",
                "Wang Chau": "Wang Chau",
                "Wang Toi Shan": "Wang Toi Shan",
                "Yuen Long": "Yuen Long",
            },
        },
        districtEnOp: {
            "Central and Western District": {
                Admiralty: "Admiralty",
                Central: "Central",
                "Kennedy Town": "Kennedy Town",
                "Mid-levels": "Mid-levels",
                "Sheung Wan": "Sheung Wan",
                "Shek Tong Tsui": "Shek Tong Tsui",
                "Sai Ying Pun": "Sai Ying Pun",
                "The Peak": "The Peak",
                "West Point": "West Point",
            },
            "Eastern District": {
                "Braemar Hill": "Braemar Hill",
                "Chai Wan": "Chai Wan",
                "Fortress Hill": "Fortress Hill",
                "Heng Fa Chuen": "Heng Fa Chuen",
                "North Point": "North Point",
                "Quarry Bay": "Quarry Bay",
                "Shau Kei Wan": "Shau Kei Wan",
                "Siu Sai Wan": "Siu Sai Wan",
                "Sai Wan Ho": "Sai Wan Ho",
                "Tin Hau": "Tin Hau",
                "Tai Koo": "Tai Koo",
            },
            "Southern District": {
                Aberdeen: "Aberdeen",
                "Ap Lei Chau": "Ap Lei Chau",
                "Chung Hom Kok": "Chung Hom Kok",
                "Deep Water Bay": "Deep Water Bay",
                "Pok Fu Lam": "Pok Fu Lam",
                "Repulse Bay": "Repulse Bay",
                "Shouson Hill": "Shouson Hill",
                "Shek O": "Shek O",
                Stanley: "Stanley",
                "Tai Tam": "Tai Tam",
                "Tin Wan": "Tin Wan",
                "Wong Chuk Hang": "Wong Chuk Hang",
                "Wong Nai Chung": "Wong Nai Chung",
            },
            "Wan Chai District": {
                "Causeway Bay": "Causeway Bay",
                "Happy Valley": "Happy Valley",
                "So Kon Po": "So Kon Po",
                "Tai Hang": "Tai Hang",
                "Wan Chai": "Wan Chai",
            },
            "Kowloon City District": {
                "Ho Man Tin": "Ho Man Tin",
                "Hung Hom": "Hung Hom",
                "Kowloon City": "Kowloon City",
                "Kowloon Tong": "Kowloon Tong",
                "Kai Tak": "Kai Tak",
                "Ma Tau Chung": "Ma Tau Chung",
                "Ma Tau Wai": "Ma Tau Wai",
                "To Kwa Wan": "To Kwa Wan",
                Whampoa: "Whampoa",
            },
            "Kwun Tong District": {
                "Cha Kwo Ling": "Cha Kwo Ling",
                "Kowloon Bay": "Kowloon Bay",
                "Kwun Tong": "Kwun Tong",
                "Lam Tin": "Lam Tin",
                "Lei Yue Mun": "Lei Yue Mun",
                "Ngau Tau Kok": "Ngau Tau Kok",
                "Sau Mau Ping": "Sau Mau Ping",
                "Yau Tong": "Yau Tong",
            },
            "Sham Shui Po District": {
                "Cheung Sha Wan": "Cheung Sha Wan",
                "Lai Chi Kok": "Lai Chi Kok",
                "Mei Foo": "Mei Foo",
                "Nam Cheong": "Nam Cheong",
                "Stonecutters Island": "Stonecutters Island",
                "Shek Kip Mei": "Shek Kip Mei",
                "Sham Shui Po": "Sham Shui Po",
                "Tai Kok Tsui": "Tai Kok Tsui",
                "Tai Wo Ping": "Tai Wo Ping",
                "Yau Yat Tsuen": "Yau Yat Tsuen",
            },
            "Wong Tai Sin District": {
                "Choi Hung": "Choi Hung",
                "Diamond Hill": "Diamond Hill",
                "Lok Fu": "Lok Fu",
                "Ngau Chi Wan": "Ngau Chi Wan",
                "San Po Kong": "San Po Kong",
                "Tsz Wan Shan": "Tsz Wan Shan",
                "Wang Tau Hom": "Wang Tau Hom",
                "Wong Tai Sin": "Wong Tai Sin",
            },
            "Yau Tsim Mong District": {
                "Ferry Point": "Ferry Point",
                Jordan: "Jordan",
                "Mong Kok": "Mong Kok",
                "Prince Edward": "Prince Edward",
                "Tsim Sha Tsui": "Tsim Sha Tsui",
                "West Kowloon": "West Kowloon",
                "Yau Ma Tei": "Yau Ma Tei",
            },
            "Islands District": {
                "Cheung Chau": "Cheung Chau",
                "Cheung Sha Lantau Island": "Cheung Sha Lantau Island",
                "Chek Lap Kok Lantau Island": "Chek Lap Kok Lantau Island",
                "Chi Ma Wan Lantau Island": "Chi Ma Wan Lantau Island",
                "Discovery Bay Lantau Island": "Discovery Bay Lantau Island",
                Disneyland: "Disneyland",
                "Disneyland Resort": "Disneyland Resort",
                "Hei Ling Chau": "Hei Ling Chau",
                "Lantau Island": "Lantau Island",
                "Lamma Island": "Lamma Island",
                "Mui Wo Lantau Island": "Mui Wo Lantau Island",
                "Ngong Ping Lantau Island": "Ngong Ping Lantau Island",
                "Peng Chau": "Peng Chau",
                "Poi Toi Island": "Poi Toi Island",
                "Shek Pik Lantau Island": "Shek Pik Lantau Island",
                "Shek Kwu Chau": "Shek Kwu Chau",
                "Sha Lo Wan": "Sha Lo Wan",
                "Tai O Lantau Island": "Tai O Lantau Island",
                "Tong Fuk Lantau Island": "Tong Fuk Lantau Island",
                "Tung Peng Chau": "Tung Peng Chau",
                "Tung Chung Lantau Island": "Tung Chung Lantau Island",
            },
            "Kwai Tsing District": {
                "Kwai Fong": "Kwai Fong",
                "Kwai Hing": "Kwai Hing",
                "Kwai Shing": "Kwai Shing",
                "Kwai Chung": "Kwai Chung",
                "Lai King": "Lai King",
                "Shek Lei": "Shek Lei",
                "Tsing Yi": "Tsing Yi",
                "Tai Wo Hau": "Tai Wo Hau",
            },
            "North District": {
                "Crooked Island": "Crooked Island",
                Fanling: "Fanling",
                "Hang Tau": "Hang Tau",
                "Kat O": "Kat O",
                "Kwu Tung": "Kwu Tung",
                "Lo Wu": "Lo Wu",
                "Luen Wo Hui": "Luen Wo Hui",
                "Lung Yeuk Tau": "Lung Yeuk Tau",
                "Man Kam To": "Man Kam To",
                "Muk Wu": "Muk Wu",
                "Ping Che": "Ping Che",
                "Sheung Shui": "Sheung Shui",
                "Sandy Ridge": "Sandy Ridge",
                "Sha Tau Kok": "Sha Tau Kok",
                "Shek Wu Hui": "Shek Wu Hui",
                "Tsiu Hang": "Tsiu Hang",
                "Ta Kwu Ling": "Ta Kwu Ling",
                "Wong Kong Shan": "Wong Kong Shan",
            },
            "Sai Kung District": {
                "Clear Water Bay": "Clear Water Bay",
                "Fei Ngo Shan": "Fei Ngo Shan",
                "Hang Hau Sai Kung": "Hang Hau Sai Kung",
                "Kau Sai Chau": "Kau Sai Chau",
                "Lohas Park": "Lohas Park",
                "Leung Shuen Wan": "Leung Shuen Wan",
                "Po Lam": "Po Lam",
                "Po Lo Che": "Po Lo Che",
                "Pak Shek Wo": "Pak Shek Wo",
                "Pak Sha Wan": "Pak Sha Wan",
                "Pak Tam Chung": "Pak Tam Chung",
                "Pik Uk": "Pik Uk",
                "Sai Kung": "Sai Kung",
                "Sha Kok Mei": "Sha Kok Mei",
                "Tiu Keng Leng": "Tiu Keng Leng",
                "Tseung Kwan O": "Tseung Kwan O",
                "Tung Lung Chau": "Tung Lung Chau",
                "Tui Min Hoi": "Tui Min Hoi",
            },
            "Sha Tin District": {
                "A Kung Kok": "A Kung Kok",
                "Che Kung Miu": "Che Kung Miu",
                "Fo Tan Sha Tin": "Fo Tan Sha Tin",
                "Hin Keng": "Hin Keng",
                "Heng On": "Heng On",
                "Kau To Shan": "Kau To Shan",
                "Ma Liu Shui": "Ma Liu Shui",
                "Ma On Shan": "Ma On Shan",
                "Pak Shek Kok": "Pak Shek Kok",
                "Sha Tin": "Sha Tin",
                "Siu Lek Yuen Sha Tin": "Siu Lek Yuen Sha Tin",
                "Shek Mun": "Shek Mun",
                "Sha Tin Wai": "Sha Tin Wai",
                "Sui Wo": "Sui Wo",
                "Tai Wai Sha Tin": "Tai Wai Sha Tin",
                "Wu Kai Sha": "Wu Kai Sha",
            },
            "Tuen Mun District": {
                "Castle Peak Bay": "Castle Peak Bay",
                "Fu Tei Tuen Mun": "Fu Tei Tuen Mun",
                "Kau Hui": "Kau Hui",
                "Lung Kwu Tan": "Lung Kwu Tan",
                "Lam Tei Tuen Mun": "Lam Tei Tuen Mun",
                "San Hui Tuen Mun": "San Hui Tuen Mun",
                "Siu Lam Tuen Mun": "Siu Lam Tuen Mun",
                "So Kwun Wat": "So Kwun Wat",
                "Tai Lam": "Tai Lam",
                "Tuen Mun": "Tuen Mun",
            },
            "Tai Po District": {
                "Cheung Muk Tau": "Cheung Muk Tau",
                "Kau Lung Hang": "Kau Lung Hang",
                "Lam Tsuen Tai Po": "Lam Tsuen Tai Po",
                "Lam Tsuen Valley": "Lam Tsuen Valley",
                "Nam Hang": "Nam Hang",
                "Shap Sze Heung": "Shap Sze Heung",
                "Shuen Wan Tai Po": "Shuen Wan Tai Po",
                "Tai Po": "Tai Po",
                "Tai Wo": "Tai Wo",
                "Tap Mun": "Tap Mun",
                "Tai Mei Tuk": "Tai Mei Tuk",
                "Tai Po Kau": "Tai Po Kau",
                "Tai Po Market": "Tai Po Market",
                "Tai Po Tau": "Tai Po Tau",
                "Yuen Chau Tsai": "Yuen Chau Tsai",
            },
            "Tsuen Wan District": {
                "Lei Muk Shue": "Lei Muk Shue",
                "Lo Wai Tsuen Wan": "Lo Wai Tsuen Wan",
                "Ma Wan": "Ma Wan",
                "Sunny Bay": "Sunny Bay",
                "Sham Tseng": "Sham Tseng",
                "Ting Kau": "Ting Kau",
                "Tsing Lung Tau": "Tsing Lung Tau",
                "Tsuen Wan": "Tsuen Wan",
            },
            "Yuen Long District": {
                "Au Tau": "Au Tau",
                "Ha Tsuen Yuen Long": "Ha Tsuen Yuen Long",
                "Hung Shui Kiu": "Hung Shui Kiu",
                "Kam Tin Yuen Long": "Kam Tin Yuen Long",
                "Lau Fau Shan": "Lau Fau Shan",
                "Lok Ma Chau": "Lok Ma Chau",
                "Long Ping": "Long Ping",
                "Ma Tin": "Ma Tin",
                "Pat Heung Yuen Long": "Pat Heung Yuen Long",
                "Ping Shan Yuen Long": "Ping Shan Yuen Long",
                "San Tin Yuen Long": "San Tin Yuen Long",
                "Shek Kong Yuen Long": "Shek Kong Yuen Long",
                "Shap Pat Heung": "Shap Pat Heung",
                "Tam Mei Yuen Long": "Tam Mei Yuen Long",
                "Tin Shui Wai": "Tin Shui Wai",
                "Tai Shu Ha": "Tai Shu Ha",
                "Tai Sang Wai": "Tai Sang Wai",
                "Tai Tong Yuen Long": "Tai Tong Yuen Long",
                "Wang Chau": "Wang Chau",
                "Wang Toi Shan": "Wang Toi Shan",
                "Yuen Long": "Yuen Long",
            },
        },
        countryOp: {
            China: {
                "HK-CN": "Hong Kong",
                Mainland: "Mainland",
                Macao: "Macao",
                Taiwan: "Taiwan",
            },
            Others: {
                Afghanistan: "Afghanistan",
                "Aland-Islands": "Aland Islands",
                Albania: "Albania",
                Algeria: "Algeria",
                "American-Siamoa": "American Siamoa",
                Andorra: "Andorra",
                Angola: "Angola",
                Anguilla: "Anguilla",
                Antarctica: "Antarctica",
                "Antigua-Barbuda": "Antigua and Barbuda",
                Argentina: "Argentina",
                Armenia: "Armenia",
                Aruba: "Aruba",
                Australia: "Australia",
                Austria: "Austria",
                Azerbaijan: "Azerbaijan",
                Bahamas: "Bahamas",
                Bahrain: "Bahrain",
                Bangladesh: "Bangladesh",
                Barbados: "Barbados",
                Belarus: "Belarus",
                Belgium: "Belgium",
                Belize: "Belize",
                Benin: "Benin",
                Bermuda: "Bermuda",
                Bhutan: "Bhutan",
                Bolivia: "Bolivia",
                "Bosnia-Herzegovina": "Bosnia and Herzegovina",
                Botswana: "Botswana",
                "Bouvet-Island": "Bouvet Island",
                Brazil: "Brazil",
                "British-Indian-Ocean-Territory":
                    "British Indian Ocean Territory",
                "Brunei-Darussalam": "Brunei Darussalam",
                Bulgaria: "Bulgaria",
                "Burkina-Faso": "Burkina Faso",
                Burundi: "Burundi",
                Cambodia: "Cambodia",
                Cameroon: "Cameroon",
                Canada: "Canada",
                "Cape-Verde": "Cape Verde",
                "Cayman-Islands": "Cayman Islands",
                "Central-African-Republic": "Central African Republic",
                Chad: "Chad",
                Chile: "Chile",
                "Christmas-Island": "Christmas Island",
                "Cocos(Keeling)-Islands": "Cocos (Keeling) Islands",
                Colombia: "Colombia",
                Comoros: "Comoros",
                Congo: "Congo",
                "Cook-Islands": "Cook Islands",
                "Costa-Rica": "Costa Rica",
                "Cote-D'Ivoire": "Cote D'Ivoire",
                Croatia: "Croatia",
                Cuba: "Cuba",
                Cyprus: "Cyprus",
                "Czech-Republic": "Czech Republic",
                "Democratic-People's-Republic-of-Korea":
                    "Democratic People's Republic of Korea",
                Denmark: "Denmark",
                Djibouti: "Djibouti",
                Dominica: "Dominica",
                "Dominican-Republic": "Dominican Republic",
                Ecuador: "Ecuador",
                Egypt: "Egypt",
                El: "El Salvador",
                Equatorial: "Equatorial Guinea",
                Eritrea: "Eritrea",
                Estonia: "Estonia",
                Ethiopia: "Ethiopia",
                "Falkland-Islands": "Falkland Islands (Malvinas)",
                "Faroe-Islands": "Faroe Islands",
                "Federated-States-of-Micronesia":
                    "Federated States of Micronesia",
                Fiji: "Fiji",
                Finland: "Finland",
                France: "France",
                "French-Guiana": "French Guiana",
                "French-Polynesia": "French Polynesia",
                "French-Southern-Territories": "French Southern Territories",
                Gabon: "Gabon",
                Gambia: "Gambia",
                Georgia: "Georgia",
                Germany: "Germany",
                Ghana: "Ghana",
                Gibraltar: "Gibraltar",
                Greece: "Greece",
                Greenland: "Greenland",
                Grenada: "Grenada",
                Guadeloupe: "Guadeloupe",
                Guam: "Guam",
                Guatemala: "Guatemala",
                Guernsey: "Guernsey",
                Guinea: "Guinea",
                "Guinea-Bissau": "Guinea-Bissau",
                Guyana: "Guyana",
                Haiti: "Haiti",
                "Heard-Island-and-Mcdonald-Islands":
                    "Heard Island and Mcdonald Islands",
                "Holy-See": "Holy See (Vatican City State)",
                Honduras: "Honduras",
                Hungary: "Hungary",
                Iceland: "Iceland",
                India: "India",
                Indonesia: "Indonesia",
                Iraq: "Iraq",
                Ireland: "Ireland",
                "Islamic-Republic": "Islamic Republic of Iran",
                "Isle-of-Man": "Isle of Man",
                Israel: "Israel",
                Italy: "Italy",
                Jamaica: "Jamaica",
                Japan: "Japan",
                Jersey: "Jersey",
                Jordan: "Jordan",
                Kazakhstan: "Kazakhstan",
                Kenya: "Kenya",
                Kiribati: "Kiribati",
                Kuwait: "Kuwait",
                Kyrgyzstan: "Kyrgyzstan",
                Laos: "Lao People's Democratic Republic",
                Latvia: "Latvia",
                Lebanon: "Lebanon",
                Lesotho: "Lesotho",
                Liberia: "Liberia",
                Libya: "Libyan Arab Jamahiriya",
                Liechtenstein: "Liechtenstein",
                Lithuania: "Lithuania",
                Luxembourg: "Luxembourg",
                Madagascar: "Madagascar",
                Malawi: "Malawi",
                Malaysia: "Malaysia",
                Maldives: "Maldives",
                Mali: "Mali",
                Malta: "Malta",
                "Marshall-Islands": "Marshall Islands",
                Martinique: "Martinique",
                Mauritania: "Mauritania",
                Mauritius: "Mauritius",
                Mayotte: "Mayotte",
                Mexico: "Mexico",
                Monaco: "Monaco",
                Mongolia: "Mongolia",
                Montenegro: "Montenegro",
                Montserrat: "Montserrat",
                Morocco: "Morocco",
                Mozambique: "Mozambique",
                Myanmar: "Myanmar",
                Namibia: "Namibia",
                Nauru: "Nauru",
                Nepal: "Nepal",
                Netherlands: "Netherlands",
                "Netherlands-Antilles": "Netherlands Antilles",
                "New-Caledonia": "New Caledonia",
                "New-Zealand": "New Zealand",
                Nicaragua: "Nicaragua",
                Niger: "Niger",
                Nigeria: "Nigeria",
                Niue: "Niue",
                "Norfolk-Island": "Norfolk Island",
                "Northern-Mariana-Islands": "Northern Mariana Islands",
                Norway: "Norway",
                Oman: "Oman",
                Pakistan: "Pakistan",
                Palau: "Palau",
                Palestinian: "Palestinian Territory, Occupied",
                Panama: "Panama",
                "Papua-New-Guinea": "Papua New Guinea",
                Paraguay: "Paraguay",
                Peru: "Peru",
                Philippines: "Philippines",
                Pitcairn: "Pitcairn",
                Poland: "Poland",
                Portugal: "Portugal",
                "Puerto-Rico": "Puerto Rico",
                Qatar: "Qatar",
                "Republic-of-Korea": "Republic of Korea",
                Macedonia: "Republic of Macedonia",
                Moldova: "Republic of Moldova",
                Reunion: "Reunion",
                Romania: "Romania",
                Russian: "Russian Federation",
                Rwanda: "Rwanda",
                "Saint-Helena": "Saint Helena",
                "Saint-Kitts-Nevis": "Saint Kitts and Nevis",
                "Saint-Lucia": "Saint Lucia",
                "Saint-Pierre-Miquelon": "Saint Pierre and Miquelon",
                "Saint-Vincent-Grenadines": "Saint Vincent and The Grenadines",
                Samoa: "Samoa",
                "San-Marino": "San Marino",
                "Sao-Tome-Principe": "Sao Tome and Principe",
                "Saudi-Arabia": "Saudi Arabia",
                Senegal: "Senegal",
                Serbia: "Serbia",
                Seychelles: "Seychelles",
                "Sierra-Leone": "Sierra Leone",
                Singapore: "Singapore",
                Slovakia: "Slovakia",
                Slovenia: "Slovenia",
                "Solomon-Islands": "Solomon Islands",
                Somalia: "Somalia",
                "South-Africa": "South Africa",
                "South-Georgia-South-Sandwich-Islands":
                    "South Georgia and The South Sandwich Islands",
                Spain: "Spain",
                "Sri-Lanka": "Sri Lanka",
                Sudan: "Sudan",
                Suriname: "Suriname",
                "Svalbard-Jan-Mayen": "Svalbard and Jan Mayen",
                Swaziland: "Swaziland",
                Sweden: "Sweden",
                Switzerland: "Switzerland",
                "Syrian-Arab-Republic": "Syrian Arab Republic",
                Tajikistan: "Tajikistan",
                Tanzania: "Tanzania",
                Thailand: "Thailand",
                "The-Democratic-Republic-Congo":
                    "The Democratic Republic of The Congo",
                "Timor-Leste": "Timor-Leste",
                Togo: "Togo",
                Tokelau: "Tokelau",
                Tonga: "Tonga",
                "Trinidad-Tobago": "Trinidad and Tobago",
                Tunisia: "Tunisia",
                Turkey: "Turkey",
                Turkmenistan: "Turkmenistan",
                "Turks-Caicos-Islands": "Turks and Caicos Islands",
                Tuvalu: "Tuvalu",
                Uganda: "Uganda",
                Ukraine: "Ukraine",
                "United-Arab-Emirates": "United Arab Emirates",
                "United-Kingdom": "United Kingdom",
                "United-States": "United States",
                "United-States-Minor-Outlying-Islands":
                    "United States Minor Outlying Islands",
                Uruguay: "Uruguay",
                Uzbekistan: "Uzbekistan",
                Vanuatu: "Vanuatu",
                Venezuela: "Venezuela",
                "Viet-Nam": "Viet Nam",
                "Virgin-Islands-British": "Virgin Islands, British",
                "Virgin-Islands-U.S": "Virgin Islands, U.S.",
                "Wallis-Futuna": "Wallis and Futuna",
                "Western-Sahara": "Western Sahara",
                Yemen: "Yemen",
                Zambia: "Zambia",
                Zimbabwe: "Zimbabwe",
            },
        },
        instituteOp: {
            "Chu-Hai-College": "Hong Kong Chu Hai College",
            "City-University": "City University of Hong Kong",
            "Baptist-University": "Hong Kong Baptist University",
            "Metropolitan-University": "Hong Kong Metropolitan University",
            "Shue-Yan-University": "Hong Kong Shue Yan University",
            "Lingnan-University": "Lingnan University",
            "Tung-Wah-College": "Tung Wah College",
            "Chinese-University": "The Chinese University of Hong Kong",
            "Education-University": "The Education University of Hong Kong",
            "Hang-Seng-University": "The Hang Seng University of Hong Kong",
            Academy: "The Hong Kong Academy of Performing Arts",
            "Polytechnic-University": "The Hong Kong Polytechnic University",
            "Science-Technology":
                "The Hong Kong University of Science and Technology",
            University: "The University of Hong Kong",
            Others: "Others",
        },
        programmeNameOp: {
            postgraduateDiplomaEducation: "Postgraduate Diploma in Education",
            postgraduateCertificateEducation:
                "Postgraduate Certificate in Education",
            postgraduateDiplomaEducationPrimary:
                "Postgraduate Diploma in Education (Primary)",
            postgraduateDiplomaEducationSecondary:
                "Postgraduate Diploma in Education (Secondary)",
            postgraduateCertificateEducationPrimary:
                "Postgraduate Certificate in Education (Primary)",
            postgraduateCertificateEducationSecondary:
                "Postgraduate Certificate in Education (Secondary)",
            diplomaEducation: "Diploma in Education",
            certificatePrimaryEducation: "Certificate in Primary Education",
            certificateSecondaryEducation: "Certificate in Secondary Education",
            certificateEducation: "Certificate in Education",
            teacherCertificate: "Teacher Certificate",
            serviceCoursePrimary:
                "In-service Course of Training for Teachers in Primary Schools",
            serviceCourseSecondary:
                "In-service Course of Training for Teachers in Secondary Schools",
            certificateEarlyChildhoodEducation:
                "Certificate in Early Childhood Education (Chinese)",
            others: "Others",
        },
        secondaryEducationExaminationOp: {
            "05**": "5**",
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
        },
        advancedLevelExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            F: "F",
            U: "U",
        },
        GCEExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            U: "U",
        },
        CRELevelOp: {
            level2: "Level 2",
            level1: "Level 1",
            fail: "Fail",
        },
        attendanceModeOp: {
            fullTime: "Full-time",
            partTime: "Part-time",
            distanceLearning: "Distance Learning",
        },
        bandOp: {
            "9.0": "9.0",
            8.5: "8.5",
            "8.0": "8.0",
            7.5: "7.5",
            "7.0": "7.0",
            6.5: "6.5",
            "6.0": "6.0",
            5.5: "5.5",
            "5.0": "5.0",
            4.5: "4.5",
            "4.0": "4.0",
            3.5: "3.5",
            "3.0": "3.0",
            2.5: "2.5",
            "2.0": "2.0",
            1.5: "1.5",
            "1.0": "1.0",
            0.5: "0.5",
            "00": "0",
        },
        advancedLevelOp: {
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
            unclassified: "Unclassified",
        },
        languageCommissionOp: {
            pass: "Pass",
            fail: "Fail / Not taken",
        },
        attainedOp: {
            attained: "Attained",
            notAttained: "Not Attained",
            exempted: "Exempted",
        },
        putonghuaAttainedOp: {
            attained: "Attained",
            notAttained: "Not Attained",
        },
        fullTimeOrPartTimeOp: {
            fullTime: "Full-time",
            partTime: "Part-time",
        },
        teachingOp: {
            teaching: "Teaching",
            nonTeaching: "Non-teaching",
        },
        // subjectOp: {
        //     Biology: "Biology",
        //     Business: "Business, Accounting & Financial Studies",
        //     Chemistry: "Chemistry",
        //     CNHistory: "Chinese History",
        //     CNLanguage: "Chinese Language",
        //     CNLiterature: "Chinese Literature",
        //     Citizenship: "Citizenship and Social Development / Liberal Studies",
        //     AppliedTechnology: "Design and Applied Technology",
        //     Economics: "Economics",
        //     EngLanguage: "English Language",
        //     EngLiterature: "English Literature",
        //     EthicsReligious: "Ethics and Religious Studies",
        //     GeneralStudies: "General Studies",
        //     Geography: "Geography",
        //     Health: "Health Management and Social Care",
        //     History: "History",
        //     CommunicationTechnology: "Information and Communication Technology",
        //     Mathematics: "Mathematics",
        //     Music: "Music",
        //     PhysicalEducation: "Physical Education",
        //     Physics: "Physics",
        //     Putonghua: "Putonghua",
        //     Science: "Science",
        //     TechnologyLiving: "Technology and Living",
        //     TechnologyEducation: "Technology Education",
        //     TourismHospitality: "Tourism and Hospitality Studies",
        //     VisualArts: "Visual Arts",
        //     Others: "Others",
        // },
        subjectOp: [
            "Biology",
            "Business, Accounting & Financial Studies",
            "Chemistry",
            "Chinese History",
            "Chinese Language",
            "Chinese Literature",
            "Citizenship and Social Development / Liberal Studies",
            "Design and Applied Technology",
            "Economics",
            "English Language",
            "English Literature",
            "Ethics and Religious Studies",
            "General Studies",
            "Geography",
            "Health Management and Social Care",
            "History",
            "Information and Communication Technology",
            "Mathematics",
            "Music",
            "Physical Education",
            "Physics",
            "Putonghua",
            "Science",
            "Technology and Living",
            "Technology Education",
            "Tourism and Hospitality Studies",
            "Visual Arts",
        ],
        levelOp: [
            "Secondary 7",
            "Secondary 6",
            "Secondary 5",
            "Secondary 4",
            "Secondary 3",
            "Secondary 2",
            "Secondary 1",
            "Primary 6",
            "Primary 5",
            "Primary 4",
            "Primary 3",
            "Primary 2",
            "Primary 1",
            "Kindergarten 3",
            "Kindergarten 2",
            "Kindergarten 1",
        ],
        nationalSecurityResultLevelOp: {
            yes: "Yes",
            no: "No",
            na: "N.A.",
        },
    },
    errorMsg: {
        reEnterEmail:
            "Re-enter E-mail Address should be the same as E-mail Address",
        duplicatePost:
            "This email address has already been used for application of this post.  Please select another post.  If you wish to amend your submitted application data, please select “Search Application” on the homepage of the EDB Electronic Form Submission System.",
        atLeastOnePost: "Please select at least one post",
        atLeastOneSubject: "Please select at least one subject.",
        duplicateHkid:
            "The identity card number you have input has already been used for application of this post.  Please return to the previous page to select another post.  If you wish to amend your submitted application data, please select “Search Application” on the homepage of the EDB Electronic Form Submission System.",
        duplicatePassport:
            "The Passport/Travel Document Number you have input has already been used for application of this post.  Please return to the previous page to select another post.  If you wish to amend your submitted application data, please select “Search Application” on the homepage of the EDB Electronic Form Submission System.",
        duplicateDeadline:
            "If you wish to apply for this post, please submit a separate application.",
        editPost:
            "If you wish to apply for another post, please submit a separate application.",
        CREMustBeLevel2:
            "Common Recruitment Examination (CRE) - Use of Chinese must be at Level 2",
        CREofEnMustBeLevel2:
            "Common Recruitment Examination (CRE) - Use of English must be at Level 2",
        postAppliedFor:
            "Please select the post(s) you would like to apply for.",
        issuingAuthority: "Please fill in the Issuing Authority",
        permanentResident:
            "Please select whether you are a permanent resident of the Hong Kong Special Administrative Region",
        residentialAddress: "Please fill in Residential Address",
        residentialAddressRoom: "Please fill in the Room/Flat",
        residentialAddressFloor: "Please fill in the Floor",
        residentialAddressBlock: "Please fill in the Block/Building",
        residentialAddressEstate: "Please fill in the Estate",
        residentialAddressRoad: "Please fill in the Road/Street",
        residentialAddressDistrict: "Please fill in the District",
        residentialAddressCountry: "Please select Country / Region",
        correspondenceAddressDistrict: "Please select the District",
        tel1: "Please fill in Mobile Phone",
        chineseNameCode: "Please fill in Chinese Name in Code",
        institute: "Please select Institute",
        instituteOther: "Please fill in the specify part",
        attendanceMode: "Please select Mode of Attendance",
        programmeDuration: "Please fill in Duration of Programme",
        awardYear: "Please select Award Year / Expected Award Year",
        majorSubject: "Please fill in Major Subject(s)",
        minorSubject: "Please fill in Minor Subject(s)",
        programmeName: "Please fill in Programme Name",
        programmeSelectName: "Please select Programme Name",
        programmeNameOther: "Please fill in the specify part",
        institute1: "Please select Issuing Authority / Institute",
        levelAttained: "Please fill in Level Attained / to be Attained",
        dateObtained: "Please select Date Obtained / to be Obtained",
        secondaryEducationExamination:
            "Please select the best result of Hong Kong Diploma of Secondary Education Examination",
        cnCulture:
            "Please select the best result of Chinese Language and Culture",
        cnLiterature:
            "Please select the best result of Chinese Language and Literature",
        creLevel:
            "Please select the best result of Common Recruitment Examination (CRE) - Use of Chinese",
        creTestDate: "Please select Date of test",
        secondaryEducationExaminationofEn:
            "Please select the best result of Hong Kong Diploma of Secondary Education Examination",
        enCulture:
            "Please select the best result of Hong Kong Advanced Level Examination",
        enCRELevel:
            "Please select the best result of Common Recruitment Examination (CRE) - Use of English",
        enCRETestDate: "Please select Date of test",
        overallBand: "Please select the result of overall band",
        listeningBand: "Please select the result of listening band",
        readingBand: "Please select the result of reading band",
        writingBand: "Please select the result of writing band",
        speakingBand: "Please select the result of speaking band",
        enIELTSestDate: "Please select Date of test",
        advancedLevel:
            "Please select the result of General Certificate of Education",
        subjectTaughtOther: "Please fill in the specify part",
        levelTaughtOther: "Please fill in the specify part",
        disciplinaryOffenceDetails:
            "Please give details of disciplinary offence whilst in employment with the Government",
        guiltyOffenceDetails:
            "Please give details of an offence in a court of law",
        natureAndDegree: "Please indicate nature and degree of the disability",
        examinationRequired:
            "Please specify the arrangement required for examination",
        interviewRequired:
            "Please specify the arrangement required for interview",
        schoolName: "Please fill in Name of School / Organisation",
        fullTimeOrPartTime: "Please select Full-time / Part-time",
        positionHeld: "Please fill in Position Held",
        natureWork: "Please select Nature of Work",
        subjectTaught: "Please select and / or enter Subject(s) taught",
        levelTaught: "Please select and / or enter Level(s) taught",
        dutiesDescription: "Please fill in Description of Duties",
        form: "Please select the date",
        to: "Please select the date",
        ServiceTo:
            "The effective time to should be later than effective time from",
        submitTimeout:
            "Timeout has expired! Please complete your submission within two hours of entering form101!",
        submitFail: "Submission failed",
        duplicatesSubject:
            "The same subject cannot be published at the same time in the same application period.",
        workingExperienceMinimumYears:
            "Please be reminded that you should meet the post-degree working experience requirements for the post(s) you have applied for.",
        differentJob:
            'The "{{differentJob}}" job is in "Publish" status and the content has been changed, please confirm if it is saved?',
        duration: "Please fill in the Period",
        workingExperienceInputNullData: "Please fill in the Working Experience",
        requiredWithName: "Please fill in {{fieldName}}",
        requiredWithSelect: "Please select {{fieldName}}",
        atLeastOne: "Please fill in at least one of the fields above",
        atLeastOneOfItems: "Please fill int one of the items (ii) / (iii)",
        numericOnly: "Numeric Only",
        maxDigits: "Maximum {{digits}} digits Only",
        enIELTSestDateMinDate:
            "Date of test must be from {{startDate}} to {{endDate}} to be valid.",
        enIELTSestDateMinDateNew:
            "The IELTS test result (with two-year validity) must be valid on any date during the application period.",
        leastOneQualification:
            "Please fill in at least one qualification below.",
        leastOneResultCn:
            "Please input at least one result in Chinese Language Subject below.",
        leastOneResultEn:
            "Please input at least one result in English Language Subject below.",
        importantNotes:
            "Please insert a “√” in the box and press “Next” button. ",
        engSurnameRequired: "Please fill in Surname",
        engSurnameValid: "Please fill in a valid Surname",
        englishOtherNameRequired: "Please fill in Other names",
        englishOtherNameValid: "Please fill in a valid Other names",
        hkidOrPassport:
            "Please fill in Hong Kong Identity Card Number or Passport / Travel document number",
        passportValid: "Please fill in a valid Passport/Travel Document Number",
        hkidValid: "Please fill in a valid Hong Kong Identity Card Number",
        requiredAgreement:
            "Please insert a “√” in the box(es) to confirm your acceptance of the condition(s).",
        nationalSecurityResult: "Please select as appropriate",
        workFrom: "Please select the From Date",
        workTo: "Please select the To Date",
        grade: "Please fill in Grade",
        obtainedDateOfMY: "Please select Validity Date",
        maxTextLength: "Not exceeding {{max}} characters",
        gceExaminationsLevel: "Please fill in Level Attained",
        igcseForEnglishLevel: "Please fill in Level Attained",
        instituteMembershipLevel: "Please fill in Type",
        schoolOrDivision: "Please fill in School/Division/Section",
        fromDate: "Please select from date",
        toDate: "Please select to date",
        selectDate: "Please select the date",
        selectoPtion: "Please select an option",
        duplicatePublishJob:
            "'{{duplicatePublishJob}}' job already has a 'published' status, please do not duplicate publish the same job.",
    },
    editDialog: {
        title: "Notice",
        note: "Your application has been updated.",
        msg: "Please note that the amendments made to the application form have not been completed and confirmed yet.  If you still wish to make changes to the application data, please proceed to the last confirmation page and click on the “SUBMIT” button after completing the necessary amendments.",
    },
};

export default Form101EN;
